import api from "../api";

const API_BASE = "/api/Produtos";
const API_CATEGORIA = "/api/Categorias";

const listProduto = async function (
  locale: string,
  filters: { [key: string]: string | boolean },
  categoria?: string,
  isEditor?: boolean,
) {
  const params = filters;
  if (isEditor) {
    params.ProdutosEditor = isEditor;
  }

  return api.get(`${API_CATEGORIA}/${categoria}/produtos`, {
    params,
    headers: {
      "Accept-Language": locale,
    },
  });
};

const obtemProduto = async function (locale: string, codigo?: string) {
  return api.get(`${API_BASE}/${codigo}`, {
    headers: {
      "Accept-Language": locale,
    },
  });
};

const obtemCategorias = async function (locale: string, products: boolean, isEditor?: boolean) {
  const params: { [key: string]: string | boolean } = {};
  params["ComProduto"] = products;
  if (isEditor) {
    params["ProdutosEditor"] = isEditor;
  }
  return api.get(API_CATEGORIA, {
    params,
    headers: {
      "Accept-Language": locale,
    },
  });
};

const pesquisaProduto = async function (
  locale: string,
  termo: string,
  filters?: { [key: string]: string },
) {
  // @ts-ignore
  filters["pesquisa"] = termo;
  const params = filters;

  return api.get(`${API_BASE}/pesquisa`, {
    params,
    headers: {
      "Accept-Language": locale,
    },
  });
};

const destaqueProduto = async function (
  locale: string,
  termo: string,
  filters?: { [key: string]: string },
) {
  // @ts-ignore
  filters["destaque"] = termo;
  const params = filters;

  return api.get(`${API_BASE}/pesquisa`, {
    params,
    headers: {
      "Accept-Language": locale,
    },
  });
};

const assistenteBusca = async function (locale: string, filters: { [key: string]: string }) {
  return api.get(`${API_BASE}/assistente`, {
    params: filters,
    headers: {
      "Accept-Language": locale,
    },
  });
};

const produtoService = {
  listProduto,
  obtemProduto,
  obtemCategorias,
  pesquisaProduto,
  assistenteBusca,
  destaqueProduto,
};

export default produtoService;
